import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Button, Form, Row } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Footer } from '../components/Footer';
import Modal from 'react-bootstrap/Modal';
import {Trans, useTranslation } from 'react-i18next';

export default function ChangePassword(){
    const navigate = useNavigate(); 
    const { t } = useTranslation();
    const location = useLocation();
    const token = location.state.token;
    const person_code = location.state.person_code;
    
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');

    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
        navigate('/', {replace: true });
    }

    const handleShow = () => {
        setShow(true);        
    }

    const handleChangePassword = (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            setPasswordError(t('password_not_match'));
          } else {
            setPasswordError('');
           
            const headers = { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
            fetch('https://booking.bernard.vn/api/auth/changePassword', { method: "POST", headers, body: JSON.stringify({password}) })
            .then(response => {
                if(response.ok){
                    localStorage.setItem("user", JSON.stringify({ person_code: person_code, token: token }))
                    handleShow();
                }                
            });
          }
    }

    return (
        <div className='page-fullscreen'>   
            <Modal centered show={show} onHide={handleClose} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('password_changed')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t('password_changed_message')}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        {t('close')}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Header />
            <div className='page-content'>
                <Row style={{ height: 100 + '%', margin: 0 }}>
                    <div className='col-lg-6 col-xs-12 blue-bg'>
                        <div className='left-panel'>
                            <div className='login-form vertical-center'>
                                <div className='form-heading'>
                                    <div className='title'>
                                        {t('change_password')}
                                    </div>
                                    <div className='sub-title'>
                                        {t('enter_new_password')}
                                    </div>
                                </div>
                                <Form onSubmit={handleChangePassword}>
                                    <Form.Group  className="mt-3" controlId="password">
                                        <Form.Control placeholder={t('new_password')} type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                                    </Form.Group>
                                    <Form.Group controlId="confirmPassword">
                                        <Form.Control placeholder={t('retype_new_password')} type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required isInvalid={passwordError !== ''}               />
                                        {   
                                            passwordError && (<Form.Control.Feedback type="invalid">{passwordError}</Form.Control.Feedback>
                                        )}
                                    </Form.Group>                                
                                    <Form.Group className="mt-3" style={{ display: 'flex', flexDirection: 'row' }}>
                                        <Button type='submit' className='submit' style={{ width: 100 + '%' }}>{t('change_password')}</Button>
                                    </Form.Group>

                                    <Form.Group className='mt-3' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'right' }}>
                                        <Link to={'/signin'}>{t('continue_signin')}</Link>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    </div>
                    <div className='right-panel col-lg-6 col-xs-12' style={{ backgroundImage: "url(/images/bg-1.png)", backgroundSize: 'cover' }}>
                    </div>
                </Row>
            </div>
            <Footer />
        </div >
    )
}

